<template>
  <v-autocomplete dense v-model="tankId" :class="{'text-body-2':!outlined}" :outlined="outlined" :label="label"
                  no-data-text="No tanks available" max-height="300"
                  :items="tanks" item-text="name" item-value="id" :rules="[mandatory]"
                  :hint="contents" persistent-hint
                  @change="$emit('input',tankId);$emit('change',tankId)">
    <template v-slot:item="{item}">
      <v-list-item-content>
        <v-list-item-title>{{item.name}}</v-list-item-title>
        <v-list-item-subtitle class="text-caption" :class="{'green--text':highlight && highlight(item)}" v-if="hint">
          {{alcoholName(item)}}
        </v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>

</template>

<script>
export default {
  name: 'TankSelect',
  props: {
    value: {type:String, required:true},
    tanks: {type:Array, required:true},
    required: {type:Boolean, required:false, default:true},
    outlined: {type:Boolean, required:false, default:false},
    label: {type:String, required:false},
    highlight: {type:Function,required:false},
    hint: {type:Boolean, required:false, default:true}
  },
  data() {
    return {
      tankId: this.value,
      mandatory: v => !this.required || !!v || 'Required',
    }
  },
  computed: {
    contents() {
      if (!this.hint)
        return;
      const tank = this.tanks.find(tank => tank.id === this.tankId);
      if (tank)
        return this.alcoholName(tank);
    }
  },
  watch: {
    value() {
      this.tankId = this.value;
    }
  },
  methods: {
    alcoholName(tank) {
      if (tank.contents) {
        let amount = '(empty)';
        if (tank.contents.alcoholType && tank.contents.volume) {
          const spirits = tank.contents.alcoholType === 'Spirit';
          amount = `${this.$number(tank.contents.volume, 3)} ${spirits?'LAA':'litres'} ${tank.contents.alcoholName}`;
        }
        return amount;
      }
    }
  }
}
</script>